<template>
	<Layout :pageTitle="'Cobros'">
		<!-- <template #cta>
			<router-link tag="a" to="/events/create" class="btn btn-primary">Crear evento</router-link>
		</template> -->
		<template #bar>
			<div class="filters-box justify-content-between">
				<div class="filter">
					<div class="filter-input">
						<i class="icon icon-search"></i>
						<input
							type="text"
							class="form-control"
							placeholder="Buscar en cobros"
							v-model="filters.search"
							@keyup.enter="updateFilters($event)"
						/>
						<div
							class="btn btn-light btn-clear-filter"
							v-if="filters.search"
							@click="
								filters.search = null
								updateFilters()
							"
						>
							<i class="icon icon-close"></i>
						</div>
					</div>
				</div>
			</div>
		</template>

		<Loader :show="loading" type="inline" />

		<div class="main-container container p-3" v-if="!loading">
			<div class="card mt-2">
				<div class="card-body">
					<table class="table table-clickeable">
						<tr class="table-head">
							<td>Nombre</td>
							<td>Motivo</td>
							<td>Fecha de cobro</td>
							<td>Monto</td>
							<td></td>
						</tr>

						<tr v-for="item of list" :key="item.id">
							<td>
								<div class="tc">
									<span class="bolder"
										>{{ item.order.user.name }} {{ item.order.user.lastname }}</span
									>
									<span class="text-secondary">{{ item.order.user.email }}</span>
								</div>
							</td>
							<td>
								<div class="tc" v-if="item.order.membership">
									<span class="bolder" v-if="item.order.membership.membershipType"
										>{{ item.order.membership.membershipType.name }}
									</span>
								</div>
								<div class="tc" v-if="item.order.tickets && item.order.tickets.length > 0">
									<span class="bolder">{{ item.order.tickets.length }} Tickets</span>
									<span>{{ item.order.event.name }}</span>
								</div>
							</td>
							<td>
								<div class="tc">
									<span class="bolder">{{ item.paidAt | moment("DD-MM-YYYY HH:mm") }} </span>
								</div>
							</td>
							<td>
								<div class="tc">
									<span class="bolder"
										>{{ item.currencySymbol }} {{ item.amountEarned | toCurrency }}</span
									>
									<!-- <span class="text-secondary" >Pagó el </span> -->
								</div>
							</td>

							<td>
								<div class="tc">
									<span class="d-flex justify-content-end">
										<i class="dot mt-1 mr-1" :class="`dot-${item.statusClass}`"></i>
										<span>{{ item.statusText }}</span>
									</span>
								</div>
							</td>
						</tr>
					</table>

					<div class="alert alert-default text-center mt-5 mb-5" v-if="!loading && list.length == 0">
						No se han encontrado transacciones
					</div>

					<Pagination :pageData="pagination" @pageChange="pageChange" />
				</div>
			</div>
		</div>
	</Layout>
</template>

<script>
import gql from "graphql-tag"

export default {
	name: "Transactions",
	data() {
		return {
			list: [],
			loading: true
		}
	},
	beforeMount() {
		this.filters = this.getValidUrlParams()
		this.load()
	},
	methods: {
		load() {
			this.loading = true
			this.$apollo
				.query({
					query: gql`
						query($take: Int, $skip: Int, $search: String, $status: String) {
							transactions(take: $take, skip: $skip, search: $search, status: $status) {
								data {
									id
									order {
										id
										user {
											id
											name
											lastname
											email
										}
										membership {
											id
											membershipType {
												id
												name
											}
										}
										tickets {
											id
											ticketType {
												id
												name
											}
										}
										event {
											id
											name
										}
									}

									currencySymbol
									amountEarned
									acquirerName
									paidAt
									status
									statusText
									statusClass
								}
								pageInfo {
									totalItems
								}
							}
						}
					`,
					variables: {
						take: this.pagination.length,
						skip: this.pagination.skip,
						search: this.filters.search,
						status: "PAID"
					},
					fetchPolicy: "network-only"
				})
				.then(({ data }) => {
					this.list = data.transactions.data
					this.pagination.pageInfo = data.transactions.pageInfo
					this.loading = false
				})
				.catch((err) => {
					this.loading = false
				})
		}
	}
}
</script>

<style></style>
